module.exports = __webpack_public_path__ + "img/iso_9001_dnv.66fcbbca.jpg";